import { Box, Grid } from "@mui/material";
import React from "react";
import Typography from "@mui/material/Typography";
import style from "./Explore_1.module.css";
import PageButton from "../../components/PageButton";

function Explore_1() {
  return (
    <Box className={style.explorepage}>
      <Grid
        container
        className={style.main}
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid item lg={6} xs={10} className={style.wordsbox}>
          <Typography variant="h7" className={style.w100}>
            對於創業，你了解多少呢？
            <br />
            根據經濟部中小企業處創業諮詢服務中心統計，一般人創業，一年內就倒閉的機率高達90%。
            <br />
            而存活下來的10%中，又有90%會在五年內倒閉。
            <br />
            也就是說，能撐過前五年的創業家，只有1%，前五年陣亡率高達 99%。
            <br />
            儘管如此，你仍舊滿腔熱血想要創業，對吧？
            <br />
            如果你已經準備好創業的決心，請仔細閱讀接下來的資訊。
          </Typography>
        </Grid>
      </Grid>
      <div className={style.pageBtn}>
        <PageButton passPath={"/explore-4"} nextPath={"/explore-2-1"} />
      </div>
    </Box>
  );
}

export default Explore_1;
